import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=7cd7bd6c&scoped=true"
import script from "./Locale.vue?vue&type=script&lang=js"
export * from "./Locale.vue?vue&type=script&lang=js"
import style0 from "./Locale.vue?vue&type=style&index=0&id=7cd7bd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd7bd6c",
  null
  
)

export default component.exports